import { notificationMsg } from "../../utility/Notification";

const initialState = {
  claims: [],
  isVerifiedOverTimeClaimForm: false, // handle flag for submit button with validations
  inputFieldName: '',
  errorMsg: '',
  status: true,
  selectedClaimId: 0,
  isResponseUpdate: '',
  claimInfo: [],
  weekAttendaceInFormat: [],
  isLoading: false,
  isBFormRequired: true,
  BFormData: []
};

const claimsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_CLAIMS':
      return {
        ...state,
        claims: action.payload?.EmployeeClaims,
        BFormData: action.payload?.BFormData
      };
    case 'GET_MANAGERS':
      return {
        ...state,
        managers: action.payload,
      };
    case 'GET_CLAIM_INFO':
      return {
        ...state,
        claimInfo: action.payload,
        isLoading: false
      }
    case 'HANDLE_LOADING':
      return {
        ...state,
        isLoading: action.payload
      }

    case 'GET_BFORM':
      let BFormData = state.BFormData;
      if (!action.payload.error) {
        BFormData = !!(action.payload.data);
      }
      return {
        ...state,
        BFormData
      }
    case 'HANDLE_RESPONSE_MSGS':
      const { message, success, inputFieldName, claimId } = action.payload;

      return {
        ...state,
        errorMsg: message,
        status: success,
        inputFieldName: inputFieldName,
        selectedClaimId: claimId,
        isResponseUpdate: new Date()
      };

    case 'GET_WEEK_ATTENDANCE':
      return {
        ...state,
        weekAttendaceInFormat: action.payload
      }
    default:
      return { ...state };
  }
};

export default claimsReducer